jQuery(document).ready(function ($) {
    var popup = $("#customer-location-popup");
    if (popup.length < 1)
        return;
    var ip_country = getIpCountryCookie() || '';
    if (!ip_country)
        return;

    var config = JSON.parse(atob(popup.data('config')));
    var hosts = config['hosts'];

    //find suggested host
    var current = searchSuggestedHost(config.current_host?.country ?? 'US', hosts);
    var suggested = searchSuggestedHost(ip_country, hosts);
    if (!suggested['url']) {
        suggested = searchSuggestedHost('US', hosts);
    }

    var local_storage_key = "show_customer_location_popup_" + current['url'] + "_to_" + suggested['url'];

    if (current['url'] !== suggested['url'] && window.localStorage.getItem(local_storage_key) !== "no") {
        var suggested_lang = suggested.language ?? 'en';
        var text_translations = config.texts?.[suggested_lang] ?? [];

        var stay_on_site = text_translations.button_stay_on ?? '';
        stay_on_site = stay_on_site.replace("%s", current['name']);

        var go_to = text_translations.button_go_to ?? '';
        go_to = go_to.replace("%s", suggested['name'])

        $('.customer-location-popup__heading').text(text_translations.heading ?? '');
        $('.customer-location-popup__text').text(text_translations.text ?? '');
        $('.customer-location-popup__stay_on_site_button_text').text(stay_on_site);
        $('.customer-location-popup__go_to_button_text').text(go_to);

        $('.go_to_suggestion_link').attr('href', suggested['url']);
        popup.removeClass("hidden");
    }

    $('.close-customer-location-popup').on("click", function (e) {
        popup.addClass("hidden");
    });

    $('.stay_on_this_site').on("click", function(e) {
        //close => save info that we ignore that!
        window.localStorage.setItem(local_storage_key, "no");
    })
});

function searchSuggestedHost(ip_country, hosts) {
    var ret = {
        'language': 'en',
        'name': '',
        'url': ''
    };
    for (const host of hosts) {
        if (host['country'] === ip_country.toUpperCase()) {
            ret['language'] = host['language'];
            ret['name'] = host['name'];
            ret['url'] = host['current_post_translated_id'] !== '' ? host['current_post_translated_id'] : host['base_url'];
        }
    }

    return ret;
}

function getIpCountryCookie() {
    const name = "eet_ip_country=";
    const cDecoded = decodeURIComponent(document.cookie); //to be careful
    const cArr = cDecoded.split("; ");
    let res;
    cArr.forEach((val) => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
    });
    return res;
}
